import Left from '@assets/icons/left.svg'
import { Icon } from './Icon'

export const LeftIcon = Icon(Left)
